import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export const PasswordInput = ({ className = "input-base", wrapperClassName = "", testid, ...props }) => {
  const [show, setShow] = useState(false);
  const [caps, setCaps] = useState(false);
  const checkCaps = (e) => {
    if (e.getModifierState) setCaps(e.getModifierState("CapsLock"));
  };
  return (
    <div className={wrapperClassName}>
      <div className="relative">
        <input
          data-testid={testid}
          className={className + " w-full pr-10"}
          type={show ? "text" : "password"}
          onKeyDown={checkCaps}
          onKeyUp={checkCaps}
          onBlur={() => setCaps(false)}
          {...props}
        />
        <button
          type="button"
          tabIndex={-1}
          aria-label={show ? "Hide password" : "Show password"}
          title={show ? "Hide password" : "Show password"}
          data-testid={testid ? `${testid}-toggle` : undefined}
          onClick={() => setShow((s) => !s)}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#52525B] hover:text-black bg-transparent border-0 cursor-pointer p-1 grid place-items-center"
        >
          {show ? <EyeSlash size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {caps && (
        <div
          className="text-xs text-[#9A3412] mt-1 flex items-center gap-1"
          data-testid={testid ? `${testid}-capslock` : undefined}
        >
          <span aria-hidden>⇪</span> Caps Lock is on
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
